//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const REFERENCE_API_BASE_URL = new InjectionToken<string>('REFERENCE_API_BASE_URL');

export class ServiceBaseConfig {
  public key: string;
}

export class ServiceBase {
  private readonly apiKey: string;
  private readonly apimHeaderName: string = 'Ocp-Apim-Subscription-Key';
  private readonly tenantIdHeaderName: string = 'TenantId';
  private readonly tenantIdLocalStorageKey: string = 'samplicity-dtp-current-client';
  private readonly idTokenKey: string = 'samplicity-id-token';

  constructor(config: ServiceBaseConfig) {
    this.apiKey = config.key;
  }

  protected transformOptions(options: any) {
    let headers: HttpHeaders = options.headers;

    if (this.apiKey) {
      headers = headers.append(this.apimHeaderName, this.apiKey);
    }

    const tenantId = sessionStorage.getItem(this.tenantIdLocalStorageKey);
    if (tenantId) {
      headers = headers.append(this.tenantIdHeaderName, tenantId);
    }

    const token = localStorage.getItem(this.idTokenKey);
    if (token) {
      headers = headers.append('Authorization', 'Bearer ' + token);
    }

    options.headers = headers;

    return Promise.resolve(options);
  }
}

@Injectable()
export class Reference extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ServiceBaseConfig) configuration: ServiceBaseConfig, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(REFERENCE_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param typeId (optional) 
     * @return Success
     */
    getProductTypeById(typeId: string | null | undefined): Observable<AjaxResponseOfProductTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductType/GetProductTypeById?";
        if (typeId !== undefined && typeId !== null)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductTypeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductTypeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfProductTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfProductTypeDto>;
        }));
    }

    protected processGetProductTypeById(response: HttpResponseBase): Observable<AjaxResponseOfProductTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfProductTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param typeCode (optional) 
     * @return Success
     */
    getProductTypeByCode(typeCode: string | null | undefined): Observable<AjaxResponseOfProductTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductType/GetProductTypeByCode?";
        if (typeCode !== undefined && typeCode !== null)
            url_ += "typeCode=" + encodeURIComponent("" + typeCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductTypeByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductTypeByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfProductTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfProductTypeDto>;
        }));
    }

    protected processGetProductTypeByCode(response: HttpResponseBase): Observable<AjaxResponseOfProductTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfProductTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getProductTypes(): Observable<AjaxResponseOfIListOfProductTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductType/GetProductTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfIListOfProductTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfIListOfProductTypeDto>;
        }));
    }

    protected processGetProductTypes(response: HttpResponseBase): Observable<AjaxResponseOfIListOfProductTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfIListOfProductTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getWmsProductTypes(): Observable<AjaxResponseOfIListOfWmsProductTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductType/GetWmsProductTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWmsProductTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsProductTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfIListOfWmsProductTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfIListOfWmsProductTypeDto>;
        }));
    }

    protected processGetWmsProductTypes(response: HttpResponseBase): Observable<AjaxResponseOfIListOfWmsProductTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfIListOfWmsProductTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getGlobalSettings(): Observable<AjaxResponseOfIListOfGlobalSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferenceData/GetGlobalSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGlobalSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGlobalSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfIListOfGlobalSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfIListOfGlobalSettingDto>;
        }));
    }

    protected processGetGlobalSettings(response: HttpResponseBase): Observable<AjaxResponseOfIListOfGlobalSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfIListOfGlobalSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getModules(): Observable<AjaxResponseOfIListOfModuleDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferenceData/GetModules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetModules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetModules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfIListOfModuleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfIListOfModuleDto>;
        }));
    }

    protected processGetModules(response: HttpResponseBase): Observable<AjaxResponseOfIListOfModuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfIListOfModuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getContactMethodTypes(): Observable<AjaxResponseOfIListOfContactMethodTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferenceData/GetContactMethodTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetContactMethodTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactMethodTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfIListOfContactMethodTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfIListOfContactMethodTypeDto>;
        }));
    }

    protected processGetContactMethodTypes(response: HttpResponseBase): Observable<AjaxResponseOfIListOfContactMethodTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfIListOfContactMethodTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getStates(): Observable<AjaxResponseOfIListOfStateDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferenceData/GetStates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfIListOfStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfIListOfStateDto>;
        }));
    }

    protected processGetStates(response: HttpResponseBase): Observable<AjaxResponseOfIListOfStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfIListOfStateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCountries(): Observable<AjaxResponseOfIListOfCountryDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferenceData/GetCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfIListOfCountryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfIListOfCountryDto>;
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<AjaxResponseOfIListOfCountryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfIListOfCountryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getProfessionalDesignations(): Observable<AjaxResponseOfIListOfProfessionalDesignationDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferenceData/GetProfessionalDesignations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProfessionalDesignations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalDesignations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfIListOfProfessionalDesignationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfIListOfProfessionalDesignationDto>;
        }));
    }

    protected processGetProfessionalDesignations(response: HttpResponseBase): Observable<AjaxResponseOfIListOfProfessionalDesignationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfIListOfProfessionalDesignationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getOrderSources(): Observable<AjaxResponseOfIListOfOrderSourceDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferenceData/GetOrderSources";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrderSources(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderSources(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfIListOfOrderSourceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfIListOfOrderSourceDto>;
        }));
    }

    protected processGetOrderSources(response: HttpResponseBase): Observable<AjaxResponseOfIListOfOrderSourceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfIListOfOrderSourceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getOrderSourceExceptionActions(): Observable<AjaxResponseOfIListOfOrderSourceExceptionActionDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferenceData/GetOrderSourceExceptionActions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrderSourceExceptionActions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderSourceExceptionActions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfIListOfOrderSourceExceptionActionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfIListOfOrderSourceExceptionActionDto>;
        }));
    }

    protected processGetOrderSourceExceptionActions(response: HttpResponseBase): Observable<AjaxResponseOfIListOfOrderSourceExceptionActionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfIListOfOrderSourceExceptionActionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDoNotHonorExclusionReasons(): Observable<AjaxResponseOfIListOfDoNotHonorExclusionReasonDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferenceData/GetDoNotHonorExclusionReasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDoNotHonorExclusionReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoNotHonorExclusionReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfIListOfDoNotHonorExclusionReasonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfIListOfDoNotHonorExclusionReasonDto>;
        }));
    }

    protected processGetDoNotHonorExclusionReasons(response: HttpResponseBase): Observable<AjaxResponseOfIListOfDoNotHonorExclusionReasonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfIListOfDoNotHonorExclusionReasonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDoNotHonorExclusionReasonSources(): Observable<AjaxResponseOfIListOfDoNotHonorExclusionReasonSourceDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferenceData/GetDoNotHonorExclusionReasonSources";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDoNotHonorExclusionReasonSources(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoNotHonorExclusionReasonSources(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfIListOfDoNotHonorExclusionReasonSourceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfIListOfDoNotHonorExclusionReasonSourceDto>;
        }));
    }

    protected processGetDoNotHonorExclusionReasonSources(response: HttpResponseBase): Observable<AjaxResponseOfIListOfDoNotHonorExclusionReasonSourceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfIListOfDoNotHonorExclusionReasonSourceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getOrderStatusReasonTypes(): Observable<AjaxResponseOfIListOfOrderStatusReasonTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferenceData/GetOrderStatusReasonTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrderStatusReasonTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderStatusReasonTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfIListOfOrderStatusReasonTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfIListOfOrderStatusReasonTypeDto>;
        }));
    }

    protected processGetOrderStatusReasonTypes(response: HttpResponseBase): Observable<AjaxResponseOfIListOfOrderStatusReasonTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfIListOfOrderStatusReasonTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMitigationOrderStatusReasonTypes(): Observable<AjaxResponseOfIListOfOrderStatusReasonTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferenceData/GetMitigationOrderStatusReasonTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMitigationOrderStatusReasonTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMitigationOrderStatusReasonTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfIListOfOrderStatusReasonTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfIListOfOrderStatusReasonTypeDto>;
        }));
    }

    protected processGetMitigationOrderStatusReasonTypes(response: HttpResponseBase): Observable<AjaxResponseOfIListOfOrderStatusReasonTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfIListOfOrderStatusReasonTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderStatusId (optional) 
     * @return Success
     */
    getMitigationReasonTypesForOrderStatus(orderStatusId: string | null | undefined): Observable<AjaxResponseOfIListOfOrderStatusReasonTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferenceData/GetMitigationReasonTypesForOrderStatus?";
        if (orderStatusId !== undefined && orderStatusId !== null)
            url_ += "orderStatusId=" + encodeURIComponent("" + orderStatusId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMitigationReasonTypesForOrderStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMitigationReasonTypesForOrderStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfIListOfOrderStatusReasonTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfIListOfOrderStatusReasonTypeDto>;
        }));
    }

    protected processGetMitigationReasonTypesForOrderStatus(response: HttpResponseBase): Observable<AjaxResponseOfIListOfOrderStatusReasonTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfIListOfOrderStatusReasonTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getOrderStatuses(): Observable<AjaxResponseOfIListOfOrderStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferenceData/GetOrderStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrderStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfIListOfOrderStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfIListOfOrderStatusDto>;
        }));
    }

    protected processGetOrderStatuses(response: HttpResponseBase): Observable<AjaxResponseOfIListOfOrderStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfIListOfOrderStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCarriers(): Observable<AjaxResponseOfIListOfCarrierDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferenceData/GetAllCarriers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllCarriers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCarriers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfIListOfCarrierDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfIListOfCarrierDto>;
        }));
    }

    protected processGetAllCarriers(response: HttpResponseBase): Observable<AjaxResponseOfIListOfCarrierDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfIListOfCarrierDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param carrierId (optional) 
     * @return Success
     */
    getCarrierServiceTypesByCarrierId(carrierId: string | null | undefined): Observable<AjaxResponseOfIListOfCarrierServiceTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferenceData/GetCarrierServiceTypesByCarrierId?";
        if (carrierId !== undefined && carrierId !== null)
            url_ += "carrierId=" + encodeURIComponent("" + carrierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCarrierServiceTypesByCarrierId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCarrierServiceTypesByCarrierId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfIListOfCarrierServiceTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfIListOfCarrierServiceTypeDto>;
        }));
    }

    protected processGetCarrierServiceTypesByCarrierId(response: HttpResponseBase): Observable<AjaxResponseOfIListOfCarrierServiceTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfIListOfCarrierServiceTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCarrierServiceTypes(): Observable<AjaxResponseOfIListOfCarrierServiceTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferenceData/GetAllCarrierServiceTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllCarrierServiceTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCarrierServiceTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfIListOfCarrierServiceTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfIListOfCarrierServiceTypeDto>;
        }));
    }

    protected processGetAllCarrierServiceTypes(response: HttpResponseBase): Observable<AjaxResponseOfIListOfCarrierServiceTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfIListOfCarrierServiceTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCommunicationTypes(): Observable<AjaxResponseOfIListOfCommunicationTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferenceData/GetCommunicationTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCommunicationTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunicationTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfIListOfCommunicationTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfIListOfCommunicationTypeDto>;
        }));
    }

    protected processGetCommunicationTypes(response: HttpResponseBase): Observable<AjaxResponseOfIListOfCommunicationTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfIListOfCommunicationTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNormalizedReferenceData(): Observable<NormalizedReferenceDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ReferenceData/GetNormalizedReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNormalizedReferenceData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNormalizedReferenceData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NormalizedReferenceDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NormalizedReferenceDataDto[]>;
        }));
    }

    protected processGetNormalizedReferenceData(response: HttpResponseBase): Observable<NormalizedReferenceDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(NormalizedReferenceDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getKnipperHolidayDates(): Observable<KnipperHolidayDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ReferenceData/GetKnipperHolidayDates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetKnipperHolidayDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKnipperHolidayDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KnipperHolidayDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KnipperHolidayDto[]>;
        }));
    }

    protected processGetKnipperHolidayDates(response: HttpResponseBase): Observable<KnipperHolidayDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(KnipperHolidayDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }


    /**
     * @return Success
     */
    getCustomerOrderTypes(): Observable<AjaxResponseOfIListOfCustomerOrderTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferenceData/GetCustomerOrderTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(
            _observableMergeMap(transformedOptions_ => {
                return this.http.request("get", url_, transformedOptions_);
            }),
            _observableMergeMap((response_: any) => {
                return this.processGetCustomerOrderTypes(response_);
            }),
            _observableCatch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetCustomerOrderTypes(response_ as any);
                    } catch (e) {
                        return _observableThrow(e) as any as Observable<AjaxResponseOfIListOfCustomerOrderTypeDto>;
                    }
                } else
                    return _observableThrow(response_) as any as Observable<AjaxResponseOfIListOfCustomerOrderTypeDto>;
            })
        );
    }

    protected processGetCustomerOrderTypes(response: HttpResponseBase): Observable<AjaxResponseOfIListOfCustomerOrderTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AjaxResponseOfIListOfCustomerOrderTypeDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AjaxResponseOfIListOfCustomerOrderTypeDto>(null as any);
    }
}


export class AjaxResponseOfProductTypeDto implements IAjaxResponseOfProductTypeDto {
    result: ProductTypeDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfProductTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? ProductTypeDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfProductTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfProductTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfProductTypeDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfProductTypeDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfProductTypeDto {
    result: ProductTypeDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class ProductTypeDto implements IProductTypeDto {
    productTypeCode: string | undefined;
    productTypeName: string | undefined;
    defaultAOCRequiredFlag: boolean | undefined;
    lotControlledFlag: boolean | undefined;
    genericNameVisibleFlag: boolean | undefined;
    genericNameRequiredFlag: boolean | undefined;
    nationalDrugCodeVisibleFlag: boolean | undefined;
    nationalDrugCodeRequiredFlag: boolean | undefined;
    productStrengthVisibleFlag: boolean | undefined;
    productStrengthRequiredFlag: boolean | undefined;
    deaScheduleVisibleFlag: boolean | undefined;
    deaScheduleRequiredFlag: boolean | undefined;
    opioidVisibleFlag: boolean | undefined;
    opioidRequiredFlag: boolean | undefined;
    antibioticVisibleFlag: boolean | undefined;
    antibioticRequiredFlag: boolean | undefined;
    hazardousVisibleFlag: boolean | undefined;
    hazardousRequiredFlag: boolean | undefined;
    temperatureControlledVisibleFlag: boolean | undefined;
    temperatureControlledRequiredFlag: boolean | undefined;
    animalHealthVisibleFlag: boolean | undefined;
    animalHealthRequiredFlag: boolean | undefined;
    activeFlag: boolean | undefined;
    priority: number | undefined;
    names: LocalizedValue[] | undefined;
    id: string | undefined;

    constructor(data?: IProductTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productTypeCode = _data["productTypeCode"];
            this.productTypeName = _data["productTypeName"];
            this.defaultAOCRequiredFlag = _data["defaultAOCRequiredFlag"];
            this.lotControlledFlag = _data["lotControlledFlag"];
            this.genericNameVisibleFlag = _data["genericNameVisibleFlag"];
            this.genericNameRequiredFlag = _data["genericNameRequiredFlag"];
            this.nationalDrugCodeVisibleFlag = _data["nationalDrugCodeVisibleFlag"];
            this.nationalDrugCodeRequiredFlag = _data["nationalDrugCodeRequiredFlag"];
            this.productStrengthVisibleFlag = _data["productStrengthVisibleFlag"];
            this.productStrengthRequiredFlag = _data["productStrengthRequiredFlag"];
            this.deaScheduleVisibleFlag = _data["deaScheduleVisibleFlag"];
            this.deaScheduleRequiredFlag = _data["deaScheduleRequiredFlag"];
            this.opioidVisibleFlag = _data["opioidVisibleFlag"];
            this.opioidRequiredFlag = _data["opioidRequiredFlag"];
            this.antibioticVisibleFlag = _data["antibioticVisibleFlag"];
            this.antibioticRequiredFlag = _data["antibioticRequiredFlag"];
            this.hazardousVisibleFlag = _data["hazardousVisibleFlag"];
            this.hazardousRequiredFlag = _data["hazardousRequiredFlag"];
            this.temperatureControlledVisibleFlag = _data["temperatureControlledVisibleFlag"];
            this.temperatureControlledRequiredFlag = _data["temperatureControlledRequiredFlag"];
            this.animalHealthVisibleFlag = _data["animalHealthVisibleFlag"];
            this.animalHealthRequiredFlag = _data["animalHealthRequiredFlag"];
            this.activeFlag = _data["activeFlag"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names.push(LocalizedValue.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productTypeCode"] = this.productTypeCode;
        data["productTypeName"] = this.productTypeName;
        data["defaultAOCRequiredFlag"] = this.defaultAOCRequiredFlag;
        data["lotControlledFlag"] = this.lotControlledFlag;
        data["genericNameVisibleFlag"] = this.genericNameVisibleFlag;
        data["genericNameRequiredFlag"] = this.genericNameRequiredFlag;
        data["nationalDrugCodeVisibleFlag"] = this.nationalDrugCodeVisibleFlag;
        data["nationalDrugCodeRequiredFlag"] = this.nationalDrugCodeRequiredFlag;
        data["productStrengthVisibleFlag"] = this.productStrengthVisibleFlag;
        data["productStrengthRequiredFlag"] = this.productStrengthRequiredFlag;
        data["deaScheduleVisibleFlag"] = this.deaScheduleVisibleFlag;
        data["deaScheduleRequiredFlag"] = this.deaScheduleRequiredFlag;
        data["opioidVisibleFlag"] = this.opioidVisibleFlag;
        data["opioidRequiredFlag"] = this.opioidRequiredFlag;
        data["antibioticVisibleFlag"] = this.antibioticVisibleFlag;
        data["antibioticRequiredFlag"] = this.antibioticRequiredFlag;
        data["hazardousVisibleFlag"] = this.hazardousVisibleFlag;
        data["hazardousRequiredFlag"] = this.hazardousRequiredFlag;
        data["temperatureControlledVisibleFlag"] = this.temperatureControlledVisibleFlag;
        data["temperatureControlledRequiredFlag"] = this.temperatureControlledRequiredFlag;
        data["animalHealthVisibleFlag"] = this.animalHealthVisibleFlag;
        data["animalHealthRequiredFlag"] = this.animalHealthRequiredFlag;
        data["activeFlag"] = this.activeFlag;
        data["priority"] = this.priority;
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): ProductTypeDto {
        const json = this.toJSON();
        let result = new ProductTypeDto();
        result.init(json);
        return result;
    }
}

export interface IProductTypeDto {
    productTypeCode: string | undefined;
    productTypeName: string | undefined;
    defaultAOCRequiredFlag: boolean | undefined;
    lotControlledFlag: boolean | undefined;
    genericNameVisibleFlag: boolean | undefined;
    genericNameRequiredFlag: boolean | undefined;
    nationalDrugCodeVisibleFlag: boolean | undefined;
    nationalDrugCodeRequiredFlag: boolean | undefined;
    productStrengthVisibleFlag: boolean | undefined;
    productStrengthRequiredFlag: boolean | undefined;
    deaScheduleVisibleFlag: boolean | undefined;
    deaScheduleRequiredFlag: boolean | undefined;
    opioidVisibleFlag: boolean | undefined;
    opioidRequiredFlag: boolean | undefined;
    antibioticVisibleFlag: boolean | undefined;
    antibioticRequiredFlag: boolean | undefined;
    hazardousVisibleFlag: boolean | undefined;
    hazardousRequiredFlag: boolean | undefined;
    temperatureControlledVisibleFlag: boolean | undefined;
    temperatureControlledRequiredFlag: boolean | undefined;
    animalHealthVisibleFlag: boolean | undefined;
    animalHealthRequiredFlag: boolean | undefined;
    activeFlag: boolean | undefined;
    priority: number | undefined;
    names: LocalizedValue[] | undefined;
    id: string | undefined;
}

export class ErrorInfo implements IErrorInfo {
    code: number | undefined;
    message: string | undefined;
    details: string | undefined;
    validationErrors: ValidationErrorInfo[] | undefined;

    constructor(data?: IErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.details = _data["details"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors.push(ValidationErrorInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["details"] = this.details;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item.toJSON());
        }
        return data;
    }

    clone(): ErrorInfo {
        const json = this.toJSON();
        let result = new ErrorInfo();
        result.init(json);
        return result;
    }
}

export interface IErrorInfo {
    code: number | undefined;
    message: string | undefined;
    details: string | undefined;
    validationErrors: ValidationErrorInfo[] | undefined;
}

export class LocalizedValue implements ILocalizedValue {
    language: LocalizedValueLanguage | undefined;
    value: string | undefined;

    constructor(data?: ILocalizedValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): LocalizedValue {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["value"] = this.value;
        return data;
    }

    clone(): LocalizedValue {
        const json = this.toJSON();
        let result = new LocalizedValue();
        result.init(json);
        return result;
    }
}

export interface ILocalizedValue {
    language: LocalizedValueLanguage | undefined;
    value: string | undefined;
}

export class ValidationErrorInfo implements IValidationErrorInfo {
    message: string | undefined;
    members: string[] | undefined;

    constructor(data?: IValidationErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members.push(item);
            }
        }
    }

    static fromJS(data: any): ValidationErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item);
        }
        return data;
    }

    clone(): ValidationErrorInfo {
        const json = this.toJSON();
        let result = new ValidationErrorInfo();
        result.init(json);
        return result;
    }
}

export interface IValidationErrorInfo {
    message: string | undefined;
    members: string[] | undefined;
}

export class AjaxResponseOfIListOfProductTypeDto implements IAjaxResponseOfIListOfProductTypeDto {
    result: ProductTypeDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfIListOfProductTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(ProductTypeDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfIListOfProductTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfIListOfProductTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfIListOfProductTypeDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfIListOfProductTypeDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfIListOfProductTypeDto {
    result: ProductTypeDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class AjaxResponseOfIListOfWmsProductTypeDto implements IAjaxResponseOfIListOfWmsProductTypeDto {
    result: WmsProductTypeDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfIListOfWmsProductTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(WmsProductTypeDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfIListOfWmsProductTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfIListOfWmsProductTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfIListOfWmsProductTypeDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfIListOfWmsProductTypeDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfIListOfWmsProductTypeDto {
    result: WmsProductTypeDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class WmsProductTypeDto implements IWmsProductTypeDto {
    productTypeDesc: string | undefined;
    names: LocalizedValue[] | undefined;

    constructor(data?: IWmsProductTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productTypeDesc = _data["productTypeDesc"];
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names.push(LocalizedValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WmsProductTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new WmsProductTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productTypeDesc"] = this.productTypeDesc;
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item.toJSON());
        }
        return data;
    }

    clone(): WmsProductTypeDto {
        const json = this.toJSON();
        let result = new WmsProductTypeDto();
        result.init(json);
        return result;
    }
}

export interface IWmsProductTypeDto {
    productTypeDesc: string | undefined;
    names: LocalizedValue[] | undefined;
}

export class AjaxResponseOfIListOfGlobalSettingDto implements IAjaxResponseOfIListOfGlobalSettingDto {
    result: GlobalSettingDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfIListOfGlobalSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(GlobalSettingDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfIListOfGlobalSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfIListOfGlobalSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfIListOfGlobalSettingDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfIListOfGlobalSettingDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfIListOfGlobalSettingDto {
    result: GlobalSettingDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class GlobalSettingDto implements IGlobalSettingDto {
    key: string | undefined;
    value: string | undefined;
    description: string | undefined;
    id: string | undefined;

    constructor(data?: IGlobalSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GlobalSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }

    clone(): GlobalSettingDto {
        const json = this.toJSON();
        let result = new GlobalSettingDto();
        result.init(json);
        return result;
    }
}

export interface IGlobalSettingDto {
    key: string | undefined;
    value: string | undefined;
    description: string | undefined;
    id: string | undefined;
}

export class AjaxResponseOfIListOfModuleDto implements IAjaxResponseOfIListOfModuleDto {
    result: ModuleDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfIListOfModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(ModuleDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfIListOfModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfIListOfModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfIListOfModuleDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfIListOfModuleDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfIListOfModuleDto {
    result: ModuleDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class ModuleDto implements IModuleDto {
    url: string | undefined;
    baseUrlFormat: string | undefined;
    description: string | undefined;
    name: string | undefined;
    code: string | undefined;
    id: string | undefined;

    constructor(data?: IModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.baseUrlFormat = _data["baseUrlFormat"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["baseUrlFormat"] = this.baseUrlFormat;
        data["description"] = this.description;
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }

    clone(): ModuleDto {
        const json = this.toJSON();
        let result = new ModuleDto();
        result.init(json);
        return result;
    }
}

export interface IModuleDto {
    url: string | undefined;
    baseUrlFormat: string | undefined;
    description: string | undefined;
    name: string | undefined;
    code: string | undefined;
    id: string | undefined;
}

export class AjaxResponseOfIListOfContactMethodTypeDto implements IAjaxResponseOfIListOfContactMethodTypeDto {
    result: ContactMethodTypeDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfIListOfContactMethodTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(ContactMethodTypeDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfIListOfContactMethodTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfIListOfContactMethodTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfIListOfContactMethodTypeDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfIListOfContactMethodTypeDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfIListOfContactMethodTypeDto {
    result: ContactMethodTypeDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class ContactMethodTypeDto implements IContactMethodTypeDto {
    phoneNbrFlag: boolean | undefined;
    emailFlag: boolean | undefined;
    faxFlag: boolean | undefined;
    extensionFlag: boolean | undefined;
    name: string | undefined;
    code: string | undefined;
    id: string | undefined;

    constructor(data?: IContactMethodTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNbrFlag = _data["phoneNbrFlag"];
            this.emailFlag = _data["emailFlag"];
            this.faxFlag = _data["faxFlag"];
            this.extensionFlag = _data["extensionFlag"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ContactMethodTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactMethodTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNbrFlag"] = this.phoneNbrFlag;
        data["emailFlag"] = this.emailFlag;
        data["faxFlag"] = this.faxFlag;
        data["extensionFlag"] = this.extensionFlag;
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }

    clone(): ContactMethodTypeDto {
        const json = this.toJSON();
        let result = new ContactMethodTypeDto();
        result.init(json);
        return result;
    }
}

export interface IContactMethodTypeDto {
    phoneNbrFlag: boolean | undefined;
    emailFlag: boolean | undefined;
    faxFlag: boolean | undefined;
    extensionFlag: boolean | undefined;
    name: string | undefined;
    code: string | undefined;
    id: string | undefined;
}

export class AjaxResponseOfIListOfStateDto implements IAjaxResponseOfIListOfStateDto {
    result: StateDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfIListOfStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(StateDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfIListOfStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfIListOfStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfIListOfStateDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfIListOfStateDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfIListOfStateDto {
    result: StateDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class StateDto implements IStateDto {
    code: string | undefined;
    name: string | undefined;
    countryCode: string | undefined;

    constructor(data?: IStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): StateDto {
        data = typeof data === 'object' ? data : {};
        let result = new StateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["countryCode"] = this.countryCode;
        return data;
    }

    clone(): StateDto {
        const json = this.toJSON();
        let result = new StateDto();
        result.init(json);
        return result;
    }
}

export interface IStateDto {
    code: string | undefined;
    name: string | undefined;
    countryCode: string | undefined;
}

export class AjaxResponseOfIListOfCountryDto implements IAjaxResponseOfIListOfCountryDto {
    result: CountryDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfIListOfCountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(CountryDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfIListOfCountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfIListOfCountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfIListOfCountryDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfIListOfCountryDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfIListOfCountryDto {
    result: CountryDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class CountryDto implements ICountryDto {
    code: string | undefined;
    name: string | undefined;
    configJson: string | undefined;

    constructor(data?: ICountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.configJson = _data["configJson"];
        }
    }

    static fromJS(data: any): CountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["configJson"] = this.configJson;
        return data;
    }

    clone(): CountryDto {
        const json = this.toJSON();
        let result = new CountryDto();
        result.init(json);
        return result;
    }
}

export interface ICountryDto {
    code: string | undefined;
    name: string | undefined;
    configJson: string | undefined;
}

export class AjaxResponseOfIListOfProfessionalDesignationDto implements IAjaxResponseOfIListOfProfessionalDesignationDto {
    result: ProfessionalDesignationDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfIListOfProfessionalDesignationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(ProfessionalDesignationDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfIListOfProfessionalDesignationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfIListOfProfessionalDesignationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfIListOfProfessionalDesignationDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfIListOfProfessionalDesignationDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfIListOfProfessionalDesignationDto {
    result: ProfessionalDesignationDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class ProfessionalDesignationDto implements IProfessionalDesignationDto {
    comments: string | undefined;
    groupingCode: string | undefined;
    name: string | undefined;
    code: string | undefined;
    id: string | undefined;

    constructor(data?: IProfessionalDesignationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comments = _data["comments"];
            this.groupingCode = _data["groupingCode"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProfessionalDesignationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionalDesignationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comments"] = this.comments;
        data["groupingCode"] = this.groupingCode;
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }

    clone(): ProfessionalDesignationDto {
        const json = this.toJSON();
        let result = new ProfessionalDesignationDto();
        result.init(json);
        return result;
    }
}

export interface IProfessionalDesignationDto {
    comments: string | undefined;
    groupingCode: string | undefined;
    name: string | undefined;
    code: string | undefined;
    id: string | undefined;
}

export class AjaxResponseOfIListOfOrderSourceDto implements IAjaxResponseOfIListOfOrderSourceDto {
    result: OrderSourceDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfIListOfOrderSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(OrderSourceDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfIListOfOrderSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfIListOfOrderSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfIListOfOrderSourceDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfIListOfOrderSourceDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfIListOfOrderSourceDto {
    result: OrderSourceDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class OrderSourceDto implements IOrderSourceDto {
    orderSourceCode: string | undefined;
    orderSourceName: string | undefined;
    commentsText: string | undefined;
    electronicFlag: boolean | undefined;
    paperFlag: boolean | undefined;
    displaySequenceNbr: number | undefined;
    names: LocalizedValue[] | undefined;
    id: string | undefined;

    constructor(data?: IOrderSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderSourceCode = _data["orderSourceCode"];
            this.orderSourceName = _data["orderSourceName"];
            this.commentsText = _data["commentsText"];
            this.electronicFlag = _data["electronicFlag"];
            this.paperFlag = _data["paperFlag"];
            this.displaySequenceNbr = _data["displaySequenceNbr"];
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names.push(LocalizedValue.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderSourceCode"] = this.orderSourceCode;
        data["orderSourceName"] = this.orderSourceName;
        data["commentsText"] = this.commentsText;
        data["electronicFlag"] = this.electronicFlag;
        data["paperFlag"] = this.paperFlag;
        data["displaySequenceNbr"] = this.displaySequenceNbr;
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): OrderSourceDto {
        const json = this.toJSON();
        let result = new OrderSourceDto();
        result.init(json);
        return result;
    }
}

export interface IOrderSourceDto {
    orderSourceCode: string | undefined;
    orderSourceName: string | undefined;
    commentsText: string | undefined;
    electronicFlag: boolean | undefined;
    paperFlag: boolean | undefined;
    displaySequenceNbr: number | undefined;
    names: LocalizedValue[] | undefined;
    id: string | undefined;
}

export class AjaxResponseOfIListOfOrderSourceExceptionActionDto implements IAjaxResponseOfIListOfOrderSourceExceptionActionDto {
    result: OrderSourceExceptionActionDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfIListOfOrderSourceExceptionActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(OrderSourceExceptionActionDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfIListOfOrderSourceExceptionActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfIListOfOrderSourceExceptionActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfIListOfOrderSourceExceptionActionDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfIListOfOrderSourceExceptionActionDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfIListOfOrderSourceExceptionActionDto {
    result: OrderSourceExceptionActionDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class OrderSourceExceptionActionDto implements IOrderSourceExceptionActionDto {
    orderSourceId: string | undefined;
    orderSourceClassificationValueId: string | undefined;
    id: string | undefined;

    constructor(data?: IOrderSourceExceptionActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderSourceId = _data["orderSourceId"];
            this.orderSourceClassificationValueId = _data["orderSourceClassificationValueId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderSourceExceptionActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSourceExceptionActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderSourceId"] = this.orderSourceId;
        data["orderSourceClassificationValueId"] = this.orderSourceClassificationValueId;
        data["id"] = this.id;
        return data;
    }

    clone(): OrderSourceExceptionActionDto {
        const json = this.toJSON();
        let result = new OrderSourceExceptionActionDto();
        result.init(json);
        return result;
    }
}

export interface IOrderSourceExceptionActionDto {
    orderSourceId: string | undefined;
    orderSourceClassificationValueId: string | undefined;
    id: string | undefined;
}

export class AjaxResponseOfIListOfDoNotHonorExclusionReasonDto implements IAjaxResponseOfIListOfDoNotHonorExclusionReasonDto {
    result: DoNotHonorExclusionReasonDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfIListOfDoNotHonorExclusionReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(DoNotHonorExclusionReasonDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfIListOfDoNotHonorExclusionReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfIListOfDoNotHonorExclusionReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfIListOfDoNotHonorExclusionReasonDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfIListOfDoNotHonorExclusionReasonDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfIListOfDoNotHonorExclusionReasonDto {
    result: DoNotHonorExclusionReasonDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class DoNotHonorExclusionReasonDto implements IDoNotHonorExclusionReasonDto {
    doNotHonorExclusionReasonCode: string | undefined;
    doNotHonorExclusionReasonName: string | undefined;
    ableToDeleteFlag: boolean | undefined;
    programLevelFlag: boolean | undefined;
    brandLevelFlag: boolean | undefined;
    productLevelFlag: boolean | undefined;
    selectableFlag: boolean | undefined;
    id: string | undefined;

    constructor(data?: IDoNotHonorExclusionReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doNotHonorExclusionReasonCode = _data["doNotHonorExclusionReasonCode"];
            this.doNotHonorExclusionReasonName = _data["doNotHonorExclusionReasonName"];
            this.ableToDeleteFlag = _data["ableToDeleteFlag"];
            this.programLevelFlag = _data["programLevelFlag"];
            this.brandLevelFlag = _data["brandLevelFlag"];
            this.productLevelFlag = _data["productLevelFlag"];
            this.selectableFlag = _data["selectableFlag"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DoNotHonorExclusionReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoNotHonorExclusionReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doNotHonorExclusionReasonCode"] = this.doNotHonorExclusionReasonCode;
        data["doNotHonorExclusionReasonName"] = this.doNotHonorExclusionReasonName;
        data["ableToDeleteFlag"] = this.ableToDeleteFlag;
        data["programLevelFlag"] = this.programLevelFlag;
        data["brandLevelFlag"] = this.brandLevelFlag;
        data["productLevelFlag"] = this.productLevelFlag;
        data["selectableFlag"] = this.selectableFlag;
        data["id"] = this.id;
        return data;
    }

    clone(): DoNotHonorExclusionReasonDto {
        const json = this.toJSON();
        let result = new DoNotHonorExclusionReasonDto();
        result.init(json);
        return result;
    }
}

export interface IDoNotHonorExclusionReasonDto {
    doNotHonorExclusionReasonCode: string | undefined;
    doNotHonorExclusionReasonName: string | undefined;
    ableToDeleteFlag: boolean | undefined;
    programLevelFlag: boolean | undefined;
    brandLevelFlag: boolean | undefined;
    productLevelFlag: boolean | undefined;
    selectableFlag: boolean | undefined;
    id: string | undefined;
}

export class AjaxResponseOfIListOfDoNotHonorExclusionReasonSourceDto implements IAjaxResponseOfIListOfDoNotHonorExclusionReasonSourceDto {
    result: DoNotHonorExclusionReasonSourceDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfIListOfDoNotHonorExclusionReasonSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(DoNotHonorExclusionReasonSourceDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfIListOfDoNotHonorExclusionReasonSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfIListOfDoNotHonorExclusionReasonSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfIListOfDoNotHonorExclusionReasonSourceDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfIListOfDoNotHonorExclusionReasonSourceDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfIListOfDoNotHonorExclusionReasonSourceDto {
    result: DoNotHonorExclusionReasonSourceDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class DoNotHonorExclusionReasonSourceDto implements IDoNotHonorExclusionReasonSourceDto {
    doNotHonorExclusionReasonId: string | undefined;
    sourceClassificationValueId: string | undefined;
    id: string | undefined;

    constructor(data?: IDoNotHonorExclusionReasonSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doNotHonorExclusionReasonId = _data["doNotHonorExclusionReasonId"];
            this.sourceClassificationValueId = _data["sourceClassificationValueId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DoNotHonorExclusionReasonSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoNotHonorExclusionReasonSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doNotHonorExclusionReasonId"] = this.doNotHonorExclusionReasonId;
        data["sourceClassificationValueId"] = this.sourceClassificationValueId;
        data["id"] = this.id;
        return data;
    }

    clone(): DoNotHonorExclusionReasonSourceDto {
        const json = this.toJSON();
        let result = new DoNotHonorExclusionReasonSourceDto();
        result.init(json);
        return result;
    }
}

export interface IDoNotHonorExclusionReasonSourceDto {
    doNotHonorExclusionReasonId: string | undefined;
    sourceClassificationValueId: string | undefined;
    id: string | undefined;
}

export class AjaxResponseOfIListOfOrderStatusReasonTypeDto implements IAjaxResponseOfIListOfOrderStatusReasonTypeDto {
    result: OrderStatusReasonTypeDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfIListOfOrderStatusReasonTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(OrderStatusReasonTypeDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfIListOfOrderStatusReasonTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfIListOfOrderStatusReasonTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfIListOfOrderStatusReasonTypeDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfIListOfOrderStatusReasonTypeDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfIListOfOrderStatusReasonTypeDto {
    result: OrderStatusReasonTypeDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class OrderStatusReasonTypeDto implements IOrderStatusReasonTypeDto {
    name: string | undefined;
    code: string | undefined;
    id: string | undefined;

    constructor(data?: IOrderStatusReasonTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderStatusReasonTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatusReasonTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }

    clone(): OrderStatusReasonTypeDto {
        const json = this.toJSON();
        let result = new OrderStatusReasonTypeDto();
        result.init(json);
        return result;
    }
}

export interface IOrderStatusReasonTypeDto {
    name: string | undefined;
    code: string | undefined;
    id: string | undefined;
}

export class AjaxResponseOfIListOfOrderStatusDto implements IAjaxResponseOfIListOfOrderStatusDto {
    result: OrderStatusDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfIListOfOrderStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(OrderStatusDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfIListOfOrderStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfIListOfOrderStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfIListOfOrderStatusDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfIListOfOrderStatusDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfIListOfOrderStatusDto {
    result: OrderStatusDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class OrderStatusDto implements IOrderStatusDto {
    initialOrderStatusFlag: boolean | undefined;
    name: string | undefined;
    code: string | undefined;
    id: string | undefined;

    constructor(data?: IOrderStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initialOrderStatusFlag = _data["initialOrderStatusFlag"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialOrderStatusFlag"] = this.initialOrderStatusFlag;
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }

    clone(): OrderStatusDto {
        const json = this.toJSON();
        let result = new OrderStatusDto();
        result.init(json);
        return result;
    }
}

export interface IOrderStatusDto {
    initialOrderStatusFlag: boolean | undefined;
    name: string | undefined;
    code: string | undefined;
    id: string | undefined;
}

export class AjaxResponseOfIListOfCarrierDto implements IAjaxResponseOfIListOfCarrierDto {
    result: CarrierDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfIListOfCarrierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(CarrierDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfIListOfCarrierDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfIListOfCarrierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfIListOfCarrierDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfIListOfCarrierDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfIListOfCarrierDto {
    result: CarrierDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class CarrierDto implements ICarrierDto {
    trackingUrlFormat: string | undefined;
    carrierServiceTypes: CarrierServiceTypeDto[] | undefined;
    names: LocalizedValue[] | undefined;
    name: string | undefined;
    code: string | undefined;
    id: string | undefined;

    constructor(data?: ICarrierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackingUrlFormat = _data["trackingUrlFormat"];
            if (Array.isArray(_data["carrierServiceTypes"])) {
                this.carrierServiceTypes = [] as any;
                for (let item of _data["carrierServiceTypes"])
                    this.carrierServiceTypes.push(CarrierServiceTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names.push(LocalizedValue.fromJS(item));
            }
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CarrierDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackingUrlFormat"] = this.trackingUrlFormat;
        if (Array.isArray(this.carrierServiceTypes)) {
            data["carrierServiceTypes"] = [];
            for (let item of this.carrierServiceTypes)
                data["carrierServiceTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }

    clone(): CarrierDto {
        const json = this.toJSON();
        let result = new CarrierDto();
        result.init(json);
        return result;
    }
}

export interface ICarrierDto {
    trackingUrlFormat: string | undefined;
    carrierServiceTypes: CarrierServiceTypeDto[] | undefined;
    names: LocalizedValue[] | undefined;
    name: string | undefined;
    code: string | undefined;
    id: string | undefined;
}

export class CarrierServiceTypeDto implements ICarrierServiceTypeDto {
    carrierServiceTypeCode: string | undefined;
    carrierServiceTypeName: string | undefined;
    carrierId: string | undefined;
    maxDaysToDeliver: number | undefined;
    names: LocalizedValue[] | undefined;
    name: string | undefined;
    code: string | undefined;
    id: string | undefined;

    constructor(data?: ICarrierServiceTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carrierServiceTypeCode = _data["carrierServiceTypeCode"];
            this.carrierServiceTypeName = _data["carrierServiceTypeName"];
            this.carrierId = _data["carrierId"];
            this.maxDaysToDeliver = _data["maxDaysToDeliver"];
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names.push(LocalizedValue.fromJS(item));
            }
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CarrierServiceTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierServiceTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carrierServiceTypeCode"] = this.carrierServiceTypeCode;
        data["carrierServiceTypeName"] = this.carrierServiceTypeName;
        data["carrierId"] = this.carrierId;
        data["maxDaysToDeliver"] = this.maxDaysToDeliver;
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }

    clone(): CarrierServiceTypeDto {
        const json = this.toJSON();
        let result = new CarrierServiceTypeDto();
        result.init(json);
        return result;
    }
}

export interface ICarrierServiceTypeDto {
    carrierServiceTypeCode: string | undefined;
    carrierServiceTypeName: string | undefined;
    carrierId: string | undefined;
    maxDaysToDeliver: number | undefined;
    names: LocalizedValue[] | undefined;
    name: string | undefined;
    code: string | undefined;
    id: string | undefined;
}

export class AjaxResponseOfIListOfCarrierServiceTypeDto implements IAjaxResponseOfIListOfCarrierServiceTypeDto {
    result: CarrierServiceTypeDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfIListOfCarrierServiceTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(CarrierServiceTypeDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfIListOfCarrierServiceTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfIListOfCarrierServiceTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfIListOfCarrierServiceTypeDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfIListOfCarrierServiceTypeDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfIListOfCarrierServiceTypeDto {
    result: CarrierServiceTypeDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class AjaxResponseOfIListOfCommunicationTypeDto implements IAjaxResponseOfIListOfCommunicationTypeDto {
    result: CommunicationTypeDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfIListOfCommunicationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(CommunicationTypeDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfIListOfCommunicationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfIListOfCommunicationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfIListOfCommunicationTypeDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfIListOfCommunicationTypeDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfIListOfCommunicationTypeDto {
    result: CommunicationTypeDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class CommunicationTypeDto implements ICommunicationTypeDto {
    communicationTypeClassificationValueId: string | undefined;
    orderFlag: boolean | undefined;
    communicationCategoryClassificationValueId: string | undefined;
    comments: string | undefined;
    name: string | undefined;
    code: string | undefined;
    id: string | undefined;

    constructor(data?: ICommunicationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.communicationTypeClassificationValueId = _data["communicationTypeClassificationValueId"];
            this.orderFlag = _data["orderFlag"];
            this.communicationCategoryClassificationValueId = _data["communicationCategoryClassificationValueId"];
            this.comments = _data["comments"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CommunicationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["communicationTypeClassificationValueId"] = this.communicationTypeClassificationValueId;
        data["orderFlag"] = this.orderFlag;
        data["communicationCategoryClassificationValueId"] = this.communicationCategoryClassificationValueId;
        data["comments"] = this.comments;
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }

    clone(): CommunicationTypeDto {
        const json = this.toJSON();
        let result = new CommunicationTypeDto();
        result.init(json);
        return result;
    }
}

export interface ICommunicationTypeDto {
    communicationTypeClassificationValueId: string | undefined;
    orderFlag: boolean | undefined;
    communicationCategoryClassificationValueId: string | undefined;
    comments: string | undefined;
    name: string | undefined;
    code: string | undefined;
    id: string | undefined;
}

export class NormalizedReferenceDataDto implements INormalizedReferenceDataDto {
    createdDateUtc: Date | undefined;
    lastModifiedUtc: Date | undefined;
    originatingSchema: string | undefined;
    originatingTable: string | undefined;
    name: string | undefined;
    code: string | undefined;
    id: string | undefined;

    constructor(data?: INormalizedReferenceDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : <any>undefined;
            this.lastModifiedUtc = _data["lastModifiedUtc"] ? new Date(_data["lastModifiedUtc"].toString()) : <any>undefined;
            this.originatingSchema = _data["originatingSchema"];
            this.originatingTable = _data["originatingTable"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NormalizedReferenceDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new NormalizedReferenceDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : <any>undefined;
        data["lastModifiedUtc"] = this.lastModifiedUtc ? this.lastModifiedUtc.toISOString() : <any>undefined;
        data["originatingSchema"] = this.originatingSchema;
        data["originatingTable"] = this.originatingTable;
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }

    clone(): NormalizedReferenceDataDto {
        const json = this.toJSON();
        let result = new NormalizedReferenceDataDto();
        result.init(json);
        return result;
    }
}

export interface INormalizedReferenceDataDto {
    createdDateUtc: Date | undefined;
    lastModifiedUtc: Date | undefined;
    originatingSchema: string | undefined;
    originatingTable: string | undefined;
    name: string | undefined;
    code: string | undefined;
    id: string | undefined;
}

export class KnipperHolidayDto implements IKnipperHolidayDto {
    holidayDate: Date | undefined;
    id: string | undefined;

    constructor(data?: IKnipperHolidayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.holidayDate = _data["holidayDate"] ? new Date(_data["holidayDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): KnipperHolidayDto {
        data = typeof data === 'object' ? data : {};
        let result = new KnipperHolidayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holidayDate"] = this.holidayDate ? this.holidayDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): KnipperHolidayDto {
        const json = this.toJSON();
        let result = new KnipperHolidayDto();
        result.init(json);
        return result;
    }
}

export interface IKnipperHolidayDto {
    holidayDate: Date | undefined;
    id: string | undefined;
}

export class AjaxResponseOfIListOfCustomerOrderTypeDto implements IAjaxResponseOfIListOfCustomerOrderTypeDto {
    result: CustomerOrderTypeDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfIListOfCustomerOrderTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(CustomerOrderTypeDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfIListOfCustomerOrderTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfIListOfCustomerOrderTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfIListOfCustomerOrderTypeDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfIListOfCustomerOrderTypeDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfIListOfCustomerOrderTypeDto {
    result: CustomerOrderTypeDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class CustomerOrderTypeDto implements ICustomerOrderTypeDto {
    customerOrderTypeCode: string | undefined;
    customerOrderTypeValue: string | undefined;
    sequence: number | undefined;
    id: string | undefined;

    constructor(data?: ICustomerOrderTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerOrderTypeCode = _data["customerOrderTypeCode"];
            this.customerOrderTypeValue = _data["customerOrderTypeValue"];
            this.sequence = _data["sequence"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomerOrderTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerOrderTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerOrderTypeCode"] = this.customerOrderTypeCode;
        data["customerOrderTypeValue"] = this.customerOrderTypeValue;
        data["sequence"] = this.sequence;
        data["id"] = this.id;
        return data;
    }

    clone(): CustomerOrderTypeDto {
        const json = this.toJSON();
        let result = new CustomerOrderTypeDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerOrderTypeDto {
    customerOrderTypeCode: string | undefined;
    customerOrderTypeValue: string | undefined;
    sequence: number | undefined;
    id: string | undefined;
}


export enum LocalizedValueLanguage {
    _0 = 0,
    _1 = 1,
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}